// Date utility functions
import { format, parseISO, isValid } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

export const formatDate = (date: string | Date, formatString: string = 'yyyy-MM-dd'): string => {
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  if (!isValid(dateObj)) {
    throw new Error('Invalid date provided');
  }
  return format(dateObj, formatString);
};

export const formatDateInTimezone = (
  date: string | Date,
  timezone: string,
  formatString: string = 'yyyy-MM-dd HH:mm:ss'
): string => {
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  if (!isValid(dateObj)) {
    throw new Error('Invalid date provided');
  }
  return formatInTimeZone(dateObj, timezone, formatString);
};

/**
 * Format date as DD-MMM-YY (e.g., "25-Jan-25")
 * This is the standard date format used across the project
 */
export const formatDateStandard = (date: string | Date): string => {
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  if (!isValid(dateObj)) {
    throw new Error('Invalid date provided');
  }
  return format(dateObj, 'dd-MMM-yy');
};
